export default {
  title: 'Выданные разрешения на строительство',
  x_axis: 'Год',
  y_axis: 'Количество разрешений',
  districts: {
    Alanya: 'Аланья',
    Konyaalti: 'Кониалты',
    Kemer: 'Кемер',
    Kepez: 'Кепез',
    Dosemealti: 'Дёшемеалты',
    Finike: 'Финике'
  }
}
